import { render, staticRenderFns } from "./create-game-service-content.vue?vue&type=template&id=bc9d71ae&scoped=true&"
import script from "./create-game-service-content.vue?vue&type=script&lang=js&"
export * from "./create-game-service-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9d71ae",
  null
  
)

export default component.exports